import { useEffect, useState } from "react";
import { useIntegrationDataService } from "./integrationDataService";
import { IntegrationCard } from "./IntegrationCard";

type Props = {
  tenantId: string;
};

export const IntegrationsList: React.FC<Props> = ({ tenantId }) => {
  const integrationService = useIntegrationDataService();
  const [integrations, setIntegrations] = useState<any[]>([]);

  const load = () => {
    integrationService.getAll(tenantId).then(setIntegrations);
  };

  useEffect(() => {
    load();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {integrations.map((item) => (
        <IntegrationCard key={item.id} integration={item} onDeleted={load} />
      ))}
    </>
  );
};
